import React, { Component } from "react";
import Header from "./Header";
import Footer from "./Footer";
import HeaderIntroLoans from "./HeaderIntroLoans";
export class HomeLoan extends Component {
  render() {
    return (
      <div>
        <Header />
        <div>
          <HeaderIntroLoans />
        </div>

        <section id="about">
          <div class="container" data-aos="fade-up">
            <header class="section-header">
              <h3>HOME LOANS</h3>
              <p>
                Buying a house is a dream for many and involves a lot of
                financial planning. We at ClipTax, aim to make it simpler for
                those who want to realize this dream. Buy, build, renovate or
                redecorate your home with our wide range of Home Loans. Enjoy
                attractive interest rates, transparent charges, quick processing
                and easy repayment options.
                <br />
                Our Home Loans extend from INR 2 Lakhs upto INR 5 Crores and
                start at an affordable interest rate of just 9.25%*. You can
                choose the home loan amount, tenure, and the EMI period as per
                your convenience. And what’s more is that our home loan
                processing involves minimum documentation and is easy and
                seamless. Moreover, our expertise in Financial Services makes us
                a reliable home loan provider you have been looking for!
              </p>
            </header>
          </div>
        </section>

        <section id="why-us">
          <div class="container" data-aos="fade-up">
            <header class="section-header">
              <h3>HOW IT WORKS?</h3>
              {/* <p>
                Any business offering sale of goods with annual turn over of 40
                lacs or service with annual turn over of 20 lacs would require
                the registration for GST and have a valid GST Number.
              </p> */}
            </header>

            <div class="row row-eq-height justify-content-center">
              <div class="col-lg-4 mb-4">
                <div class="card" data-aos="zoom-in" data-aos-delay="100">
                  <i class="fa fa-diamond"></i>
                  <div class="card-body">
                    <h5 class="card-title">Step 1:</h5>
                    <p class="card-text">
                    Quick Register : Fill up a Simple Form 

                    </p>
                    <a href="#" class="readmore">
                      Read more{" "}
                    </a>
                  </div>
                </div>
              </div>

              <div class="col-lg-4 mb-4">
                <div class="card" data-aos="zoom-in" data-aos-delay="200">
                  <i class="fa fa-language"></i>
                  <div class="card-body">
                    <h5 class="card-title">Step 2:</h5>
                    <p class="card-text">
                    Select From Multiple Offers : List of Offers from Multiple Banks 

                      Banks
                    </p>
                    <a href="#" class="readmore">
                      Read more{" "}
                    </a>
                  </div>
                </div>
              </div>

              <div class="col-lg-4 mb-4">
                <div class="card" data-aos="zoom-in" data-aos-delay="300">
                  <i class="fa fa-object-group"></i>
                  <div class="card-body">
                    <h5 class="card-title">Step 3:</h5>
                    <p class="card-text">
                      Apply : Quick Application in less than 15 mins{" "}
                    </p>
                    <a href="#" class="readmore">
                      Read more{" "}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        
        <section id="services" class="section-bg">
          <div class="container" data-aos="fade-up">
            <header class="section-header">
              <h3>DOCUMENTS REQUIRED FOR HOME LOAN</h3>
              <br />
              {/* <p>
                At ClipTax, we ensure a smooth entry for you in market, while
                guiding and assisting you through the complex procedures of
                Business Registration. Our focus is on simplifying toilsome
                procedures for incorporation of your business so that you can
                purely concentrate on your business intent. You dream, Cliptax
                executes!
              </p> */}
            </header>

            <div class="row justify-content-center">
              <div
                class="col-md-6 col-lg-5"
                data-aos="zoom-in"
                data-aos-delay="100"
              >
                <div class="box">
                  <div class="icon">
                    <i
                      class="ion-ios-analytics-outline"
                      style={{ color: "#ff689b" }}
                    ></i>
                  </div>
                  <h4 class="title">
                    <a href="">Age Proof</a>
                  </h4>
                  <p class="description">
                    A copy of your Passport, Driving License, Life Insurance Policy, Birth Certificate, PAN Cards and School Leaving Certificate
                  </p>
                </div>
              </div>
              <div
                class="col-md-6 col-lg-5"
                data-aos="zoom-in"
                data-aos-delay="200"
              >
                <div class="box">
                  <div class="icon">
                    <i
                      class="ion-ios-bookmarks-outline"
                      style={{ color: "#e9bf06" }}
                    ></i>
                  </div>
                  <h4 class="title">
                    <a href="">Photo Identity Proof</a>
                  </h4>
                  <p class="description">
                    A copy of your Voter ID/ Passport/ Driving License/ Aadhar Card/ PAN Card
                  </p>
                </div>
              </div>

              <div
                class="col-md-6 col-lg-5"
                data-aos="zoom-in"
                data-aos-delay="100"
              >
                <div class="box">
                  <div class="icon">
                    <i
                      class="ion-ios-paper-outline"
                      style={{ color: "#3fcdc7" }}
                    ></i>
                  </div>
                  <h4 class="title">
                    <a href="">Salary Slips</a>
                  </h4>
                  <p class="description">
                    A copy of your Salary Slips for the last three months
                  </p>
                </div>
              </div>
              <div
                class="col-md-6 col-lg-5"
                data-aos="zoom-in"
                data-aos-delay="200"
              >
                <div class="box">
                  <div class="icon">
                    <i
                      class="ion-ios-speedometer-outline"
                      style={{ color: "#41cf2e" }}
                    ></i>
                  </div>
                  <h4 class="title">
                    <a href="">Address Proof</a>
                  </h4>
                  <p class="description">
                    A copy of your Ration Card / Electricity Bill / Passport
                  </p>
                </div>
              </div>

              <div
                class="col-md-6 col-lg-5"
                data-aos="zoom-in"
                data-aos-delay="200"
              >
                <div class="box">
                  <div class="icon">
                    <i
                      class="ion-ios-speedometer-outline"
                      style={{ color: "#41cf2e" }}
                    ></i>
                  </div>
                  <h4 class="title">
                    <a href="">Income Proof</a>
                  </h4>
                  <p class="description">
                    A copy of your Salary account bank statements for the last six months
                  </p>
                </div>
              </div>

              <div
                class="col-md-6 col-lg-5"
                data-aos="zoom-in"
                data-aos-delay="100"
              >
                <div class="box">
                  <div class="icon">
                    <i
                      class="ion-ios-paper-outline"
                      style={{ color: "#3fcdc7" }}
                    ></i>
                  </div>
                  <h4 class="title">
                    <a href="">Existing Loan Details</a>
                  </h4>
                  <p class="description">
                    Existing loan details should be provided through bank statements
                  </p>
                </div>
              </div>

              <div
                class="col-md-6 col-lg-5"
                data-aos="zoom-in"
                data-aos-delay="100"
              >
                <div class="box">
                  <div class="icon">
                    <i
                      class="ion-ios-paper-outline"
                      style={{ color: "#3fcdc7" }}
                    ></i>
                  </div>
                  <h4 class="title">
                    <a href="">Processing Fee Cheque</a>
                  </h4>
                  <p class="description">
                    To be issued from the salary account for salaried customer or the business account in case of Self
                  </p>
                </div>
              </div>

            </div>
          </div>
        </section>
        <Footer />
      </div>
    );
  }
}

export default HomeLoan;
